import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Alert } from '../../types';

interface AlertState {
  alerts: Alert[];
  filter: {
    severity?: string[];
    acknowledged?: boolean;
    resolved?: boolean;
    facilityId?: string;
    userId?: string;
  };
  loading: boolean;
  error: string | null;
}

const initialState: AlertState = {
  alerts: [],
  filter: {},
  loading: false,
  error: null,
};

const alertsSlice = createSlice({
  name: 'alerts',
  initialState,
  reducers: {
    setAlerts: (state, action: PayloadAction<Alert[]>) => {
      state.alerts = action.payload;
      state.loading = false;
      state.error = null;
    },
    
    addAlert: (state, action: PayloadAction<Alert>) => {
      state.alerts.unshift(action.payload);
    },
    
    updateAlert: (state, action: PayloadAction<Alert>) => {
      const index = state.alerts.findIndex(a => a.id === action.payload.id);
      if (index !== -1) {
        state.alerts[index] = action.payload;
      }
    },
    
    removeAlert: (state, action: PayloadAction<string>) => {
      state.alerts = state.alerts.filter(a => a.id !== action.payload);
    },
    
    acknowledgeAlert: (state, action: PayloadAction<{ id: string; acknowledgedBy: string }>) => {
      const alert = state.alerts.find(a => a.id === action.payload.id);
      if (alert) {
        alert.acknowledged = true;
        alert.acknowledged_by = action.payload.acknowledgedBy;
        alert.acknowledged_at = Date.now();
      }
    },
    
    resolveAlert: (state, action: PayloadAction<string>) => {
      const alert = state.alerts.find(a => a.id === action.payload);
      if (alert) {
        alert.resolved = true;
        alert.resolved_at = Date.now();
      }
    },
    
    setFilter: (state, action: PayloadAction<AlertState['filter']>) => {
      state.filter = action.payload;
    },
    
    clearFilter: (state) => {
      state.filter = {};
    },
    
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setAlerts,
  addAlert,
  updateAlert,
  removeAlert,
  acknowledgeAlert,
  resolveAlert,
  setFilter,
  clearFilter,
  setLoading,
  setError,
} = alertsSlice.actions;

export default alertsSlice.reducer;
